let isIOS = false
if (navigator.platform === 'iPhone' || navigator.platform === 'iPod' || navigator.platform === 'iPad' || navigator.platform === 'MacIntel' || navigator.platform === 'Mac68K' || navigator.platform === 'MacPPC') {
  document.body.style.setProperty('font-family', 'Poppins-Regular', 'important')
  isIOS = true
}
export default{
  isIOS
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js